export enum EViewType {
  ORIGINAL = 0,
  DERIVED = 1,
  GLOBAL = 2,
  API = 3,
  NUMERICALLY_INDEXED = 4,
  HEADER_ROW_SELECTED = 5
}
